<template>
  <div class="d-flex flex-column mw-md-50 mx-auto my-2">
    <b-card no-body>
      <b-card-header header-tag="header" class="p-0" role="tab">
        <b-button block v-b-toggle.accordion-activity variant="primary" class="font-size-command-title font-weight-bold">
          {{ $t('monitoramento.resumo.tabs.comandos.atividade.title') }}
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-activity" class="p-3" role="tabpanel" visible>
        <FormTriggerActivity :vns="vns"/>
      </b-collapse>
    </b-card>    
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import FormTriggerActivity from "@/pages/vns/components/Monitor/FormTriggerActivity";

export default {
  name: "Commands",
  components: {FormTriggerActivity},
  computed: {
    ...mapGetters({
      vns: 'vns/current'
    })
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions([
    ])
  },
  async mounted() {    
  }
}
</script>

<style lang="scss" scoped>
.mw-md-50 {
  max-width: 50%;
  @media (max-width: 680px){
    max-width: 100%;
  }
}

.font-size-command-title {
  font-size: 18px !important;
}
</style>